import { getCurrentInstance } from 'vue';

export default function useValidator() {
  const instance = getCurrentInstance();
  return instance.proxy.$validator;
}
